import { render } from "./ReferenceSection.vue?vue&type=template&id=f1e11ed2"
import script from "./ReferenceSection.vue?vue&type=script&lang=js"
export * from "./ReferenceSection.vue?vue&type=script&lang=js"

import "./ReferenceSection.vue?vue&type=style&index=0&id=f1e11ed2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__